import { get } from 'lodash'
import { createSelector } from 'reselect'

import { RootState } from '@/store'

import { initialState } from './reducer'

const getState = (state: RootState) => get(state, 'spacePublisherPage', initialState)
const getNotifications = (state: RootState) => getState(state).notifications
const getPage = (state: RootState) => getState(state).page
const getResults = (state: RootState) => getState(state).results

export const getNotificationsPage = createSelector([getPage, getNotifications], ({ resourceIds }, notifications) =>
  resourceIds.map(resourceId => notifications[resourceId])
)

export const getPageStartIndex = createSelector(getPage, ({ startIndex }) => startIndex)

export const getTotalNotificationCount = createSelector(getPage, ({ totalResults }) => totalResults)

export const getNotificationById = createSelector(
  [getNotifications, (_, notificationId) => notificationId],
  (byId, notificationId) => byId[notificationId]
)

export const getNotificationResultsById = createSelector(
  [getResults, (_, notificationId) => notificationId],
  (byId, notificationId) => byId[notificationId]
)

/*
export const getSpaceNotification = (state, defaultNotification = null) => {
  let result = defaultNotification
  if (state.spacePublisherPage && state.spacePublisherPage.notification) {
    result = {
      audience: state.spacePublisherPage.notification.audience,
      category: state.spacePublisherPage.notification.category,
      hiddenAfter: state.spacePublisherPage.notification.hiddenAfter,
      location: state.spacePublisherPage.notification.location,
      hiddenBefore: state.spacePublisherPage.notification.hiddenBefore,
      source: state.spacePublisherPage.notification.source,
      summary: { ...state.spacePublisherPage.notification.summary },
      detail: state.spacePublisherPage.notification.detail ? [...state.spacePublisherPage.notification.detail] : null,
      metrics: state.spacePublisherPage.notification.metrics
        ? { ...state.spacePublisherPage.notification.metrics }
        : null,
      publisher: state.spacePublisherPage.notification.publisher
        ? { ...state.spacePublisherPage.notification.publisher }
        : null
    }
  }
  return result
}
*/
